import React, { Fragment, useContext, useState } from "react"
import { Alert } from "react-bootstrap"

import { UserContext } from "../../Contexts/UserContext/UserContext"
import useLog from "../../hooks/useLog"
import { TRANSACTIONS_PAGE_LIMIT } from "../../display_wallet"
import SkeletonText from "../../components/SkeletonText"
import { Tableau } from "../../components/Tableau"
import { Row } from "../../components/Row"
import { Spaces } from "../../components/Spaces"
import Bold from "../../components/Bold"
import { TextDisplayToken } from "../../components/TextDisplay/TextDisplay"
import Indent from "../../components/Indent"
import { toFixedDown } from "../../helpers/convert_bsv_tokens"
import { UnorderedListOutlined } from '@ant-design/icons';
import Constants from "../../config.js"
import { ButtonPrimary } from "../../components/Buttons.js"



export default function Slide_History_Tokens(props) {
    const classname = "Slide_History_Tokens: "
    const function_id = classname + "render(): "
    const log = useLog(function_id)

    const userContext = useContext(UserContext)

    const coinProps = userContext.get_selected_coin_props()
    // examples: coinProps.tokenid ticker .name .logo .color
    log("coinProps.tokenid=", coinProps.tokenid)

    const [nbloaded, set_nbloaded] = useState(null)
    const [historysize, set_historysize] = useState(null)
    const [pagelimit, set_pagelimit] = useState(TRANSACTIONS_PAGE_LIMIT)

    const update_progress = () => {
        var history_loading_progress = userContext.get_history_loading_progress()
        var _nbloaded = history_loading_progress.nbloaded
        var _historysize = history_loading_progress.size
        set_nbloaded(_nbloaded)
        set_historysize(_historysize)
    }

    if (nbloaded == null || (historysize != null && nbloaded < historysize)) {
        setTimeout(() => {
            update_progress()
        }, 700);
    }

    const owner_address = userContext.address_owner
    const ownerIsAdmin = userContext.ownerIsAdmin
    const tokensupply = userContext.tokensupply
    const tokens_txdata = userContext.tokens_txdata

    const handleSeeMore = () => {
        set_pagelimit(pagelimit + TRANSACTIONS_PAGE_LIMIT)
    }

    // by default if there's no more txs, don't display the load-more button
    var buttontitle = ""
    var show_button = false

    const multlist2d = []

    if (tokens_txdata) {
        for (var i = 0; i < tokens_txdata.length && i < pagelimit; i++) {
            var token_txdata = tokens_txdata[tokens_txdata.length - 1 - i]  // reverse order

            log("token_txdata=", JSON.stringify(token_txdata))

            let date = "", txhash = token_txdata.txhash,
                value = "", address = "", action = ""

            const txhash_url = "https://whatsonchain.com/tx/" + txhash
            date = <Fragment>
                <a href={txhash_url} target="_blank">
                    {token_txdata.date}
                </a>
            </Fragment>

            value = toFixedDown(parseFloat(token_txdata.txtime_val), 2)

            var sender = token_txdata.sender
            var receiver = token_txdata.receiver

            var action_count = "--"
            if (token_txdata.action_count)
                action_count = token_txdata.action_count

            function Red(props) {
                return (
                    <div style={{ color: "red" }}>
                        {props.children}
                    </div>
                )
            }
            function Green(props) {
                return (
                    <div style={{ color: "#00cc00", fontWeight: "bold" }}>
                        {props.children}
                    </div>
                )
            }

            action = token_txdata.action
            address = action // default

            if (action == "send") {
                date = <Red> {date} </Red>
                address = <Red> {receiver} </Red>
                value = <Red> -{value} </Red>
            }
            else if (action == "receive") {
                date = <Green> {date} </Green>
                address = <Green>{sender}</Green>
                value = <Green>+{value}</Green>
            }
            else if (action == "send_to_yourself") {
                address = "sent to yourself"
                value = "↺ " + value
            }
            else if (action == "convert") {
                address = "conversion to new contract"
                value = "↺ " + value
            }
            else if (action == "mint") {
                value = <div> +{value} </div>
            }
            else if (action == "mintuple") {
                value = <div> mintuple </div>
                address = <div> {((parseFloat(token_txdata.mintuple) - 1) * 100).toFixed(2)}% </div>
            }
            else if (action == "burn") {
                date = <Red> {token_txdata.date} </Red>
                address = <Red> {action} </Red>
                value = <Red> -{value} </Red>
            }
            else if (action == "blacklist") {
                value = <div> blacklist </div>
                address = <div> {token_txdata.blacklisted_address} </div>
            }
            else if (action == "revoked") {
                value = <div> revoke from #{token_txdata.revoke_count} </div>
                address = <div style={{ wordBreak: "break-all" }}> {token_txdata.new_token_contract_origin} </div>
            }
            else if (action == "backedup") {
                value = <div> backup contract</div>
                address = <div style={{ wordBreak: "break-all" }}> {token_txdata.new_token_contract_origin} </div>
            }
            else if (action == "frozen") {
                value = <div> freeze contract </div>
                address = <div> -- </div>
            }
            var dataline = [date, value, address]

            if (ownerIsAdmin) dataline.push(action_count)

            multlist2d.push(dataline)
        }

        if (pagelimit < tokens_txdata.length) {
            buttontitle = "Voir plus (" + (tokens_txdata.length - pagelimit) + ")"
            show_button = true
        }
    }

    var seemorebutton_jsx = show_button ?
        <center>
            <ButtonPrimary onClick={handleSeeMore}>
                {buttontitle}
            </ButtonPrimary>
        </center>
        : null

    var titles = [
        "Date",
        <Fragment>{coinProps.name} Operation</Fragment>,
        "from/to"
    ]

    var isadminmess = null

    if (ownerIsAdmin) {
        titles.push("action#")

        var supplydelphes = <SkeletonText width="4em" black />
        if (tokensupply && !isNaN(tokensupply)) {
            supplydelphes = toFixedDown(parseFloat(tokensupply), 2)
        }

        isadminmess =
            <Alert variant="warning">
                <i style={{ fontSize: "25px", marginRight: "10px" }} className="fa fa-info-circle" />
                Admin wallet detected.<br /><br />

                Adding column 'action#' to provide the unique number of each action in admin contract.
                You can use it to revoke from a specific action.<br /><br />

                Total supply :&nbsp;
                <Bold> {supplydelphes} </Bold>
            </Alert>
    }

    const has_loaded = (nbloaded != null && historysize != null && nbloaded >= historysize)

    log("has_loaded=", has_loaded, "nbloaded=", nbloaded, "historysize=", historysize)

    // only show the table loader when we have NO data at all;
    // during background refresh, keep the existing rows visible.
    const readyToDisplay = (tokens_txdata && tokens_txdata.length > 0) || has_loaded

    return (
        <div>
            <h1><UnorderedListOutlined /><Spaces count="3" />
                History of your {coinProps.name} transactions
            </h1><br />

            <center>
                <TextDisplayToken>
                    Address<Indent />
                    {owner_address ? <>
                        {userContext.isMockWallet ?
                            Constants.MOCK_WALLET_PHRASE
                            : <b>{coinProps.name_short}:{owner_address}</b>}
                    </> : <SkeletonText width="10em" />}
                </TextDisplayToken>
            </center><br />

            <Alert variant="light">
                <i style={{ fontSize: "25px", marginRight: "10px" }} className="fa fa-info-circle" />
                {/* Les transactions très récentes peuvent mettre quelques secondes à s'afficher,
                utilisez le bouton "Reload" dans le menu de gauche ou sur la page de solde
                pour resynchroniser. */}
                Very recent transactions may take a few seconds to display.
                Use the "Reload" button (sidebar or Balance page) to refresh.
            </Alert>

            {isadminmess}<br />

            {tokens_txdata ?
                <Fragment>
                    <h4>{tokens_txdata.length} {coinProps.name} Transactions
                        {!has_loaded && (
                            <span style={{ fontSize: "smaller", marginLeft: "15px" }}>
                                {nbloaded != null && historysize!=null && nbloaded != historysize?<>
                                    loading {nbloaded}/{historysize}...
                                </>:<>
                                        loading...
                                </>}
                                {/* loading {nbloaded != null ? nbloaded : 0}/{historysize != null ? historysize : '?'}... */}
                                <i className="fas fa-sync fa-spin" style={{ marginLeft: "5px" }} />
                            </span>
                        )}
                    </h4>
                    <br />
                </Fragment>
                : null}

            <Row>
                <Tableau
                    titles={titles}
                    values={multlist2d}
                    loading={!readyToDisplay}
                    empty_mess="0 transaction found."
                />
            </Row>

            {readyToDisplay ?
                seemorebutton_jsx
                : null}

        </div>
    )
}
